import {
  useCallback,
  useMemo,
  useState,
  type PropsWithChildren,
} from "react";
import {
  GUIDED_MODE_STORAGE_KEY,
  GuidedModeContext,
  storedGuidedMode,
} from "./guidedModeState";

export function GuidedModeProvider({ children }: PropsWithChildren) {
  const [enabled, setEnabledState] = useState(storedGuidedMode);
  const setEnabled = useCallback((next: boolean) => {
    try {
      window.localStorage.setItem(GUIDED_MODE_STORAGE_KEY, next ? "on" : "off");
    } catch {
      // In-memory state remains valid for this session when storage is blocked.
    }
    setEnabledState(next);
  }, []);
  const value = useMemo(
    () => ({ enabled, setEnabled }),
    [enabled, setEnabled],
  );

  return (
    <GuidedModeContext.Provider value={value}>
      {children}
    </GuidedModeContext.Provider>
  );
}
